module.exports = __webpack_public_path__ + "img/ic_edit.49f3ee9a.svg";